/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BankCreditCardItemViewModel } from "../types/BankCreditCardItemViewModel.ts";

export const bankCreditCardItemViewModelSchema = z.object({
  id: z.number().int().nullish(),
  creditCard: z.optional(z.number().int()),
  creditCardAcquirer: z.optional(z.number().int()),
  flagFee: z.string().nullish(),
}) as unknown as ToZod<BankCreditCardItemViewModel>;
